const READY_POLL_INTERVAL_MS = 250;
const READY_MAX_TRIES = 40;

export function identifyUserGuiding(user) {
  if (!user?.guid) {
    return;
  }

  const attributes = {
    name: user.name,
    email: user.email,
  };

  const run = () => window.userGuiding?.identify(user.guid, attributes);

  if (window.userGuiding) {
    run();
    return;
  }

  let tries = 0;
  const timer = setInterval(() => {
    if (window.userGuiding || tries >= READY_MAX_TRIES) {
      clearInterval(timer);
      run();
    }
    tries += 1;
  }, READY_POLL_INTERVAL_MS);
}
